import React from 'react';
import { useSelector } from 'react-redux';

import { isNoResultPageGames, isPassMaskFlowGames } from 'config/promoGameTypesClientConfig';

import MaskFlowInfoAndAction from 'client/components/infoDialog/MaskFlowInfoAndAction';

function ContainerMaskFlowInfoAndAction() {
    const { type: gameType } = useSelector(s => s.promo);
    const { currentPrizeUUID, currentUnanimationEntriesUUID } = useSelector(s => s.purePrizeState);
    const isPurePrizeGamePlayingUnOpenWinner =
        Boolean(currentPrizeUUID) && Boolean(currentUnanimationEntriesUUID);

    if (
        [
            isPurePrizeGamePlayingUnOpenWinner,
            isNoResultPageGames(gameType),
            isPassMaskFlowGames(gameType)
        ].some(e => e)
    ) {
        return null;
    }
    return <MaskFlowInfoAndAction />;
}

export default React.memo(ContainerMaskFlowInfoAndAction);
